import { useCallback, useMemo } from "react";

import { useConfirmDialogContext } from "@/features/common/contexts/useConfirmDialogContext";
import { useUserContext } from "@/features/auth/contexts/useUserContext";

export const useSignInReminder = (
  options: {
    reminderType: "dialog";
  } = {
    reminderType: "dialog",
  },
) => {
  const { user } = useUserContext();
  const { openConfirmDialog } = useConfirmDialogContext();

  const _showReminder = useCallback(() => {
    if (options?.reminderType === "dialog") {
      openConfirmDialog({
        content: "請先登入/註冊，才能使用此功能",
        onConfirm: null,
        hideActionButtons: true,
      });
    }
  }, [options.reminderType, openConfirmDialog]);

  const withSignInReminderFunctionCall = useCallback(
    (func: (...args: any) => any) => {
      if (user) {
        func();
        return;
      }

      _showReminder();
    },
    [user, _showReminder],
  );

  const signInReminderFunctionWrapper = useCallback(
    (func: (...args: any) => any) => {
      return (...args: any) => {
        withSignInReminderFunctionCall(func.bind(null, ...args));
      };
    },
    [withSignInReminderFunctionCall],
  );

  return useMemo(
    () => ({
      withSignInReminderFunctionCall,
      signInReminderFunctionWrapper,
    }),
    [withSignInReminderFunctionCall, signInReminderFunctionWrapper],
  );
};
